import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { map } from 'rxjs';
import { defaultLanguage, defaultLocations } from '../../consts';
import { getPathLanguage, getPathLocation } from '../../lib/locale-extract';
import { GrowthBookService } from '../../services/growth-book.service';

export const isNonDefaultLocaleGuard: (languages: string[]) => CanMatchFn = (languages: string[]) => (route, state) => {
  const growthBookService = inject(GrowthBookService);

  return growthBookService.load().pipe(
    map(() => {
      const path = state.map(segment => segment.path);
      const language = getPathLanguage(path);
      if (!languages.includes(language)) return false;
      const location = getPathLocation(path);
      if (language === defaultLanguage && location === defaultLocations[defaultLanguage]) return false;
      return true;
    })
  );
};
